import { arraysAreEqual } from '@proc7ts/primitives';
export const ZOptionInput = {
    /**
     * Checks whether the given command line argument is suitable to be used as option value.
     *
     * This is used by default to find option values.
     *
     * @param arg - Command line argument to check.
     *
     * @returns `true` unless argument starts with `-` and not equal to `-` itself.
     */
    isOptionValue(arg) {
        return !arg.startsWith('-') || arg === '-';
    },
    /**
     * Extracts command line option values.
     *
     * This is used by default to extract option values.
     *
     * @param args - Command line arguments.
     * @param fromIndex - First argument index to start extracting values at.
     *
     * @returns An array of command line {@link isOptionValue option values}.
     */
    valuesOf(args, fromIndex = 0) {
        let i = fromIndex;
        while (i < args.length) {
            const arg = args[i];
            if (!ZOptionInput.isOptionValue(arg)) {
                break;
            }
            ++i;
        }
        return args.slice(fromIndex, i);
    },
    /**
     * Checks whether two option inputs are equal to each other.
     * @param first
     * @param second
     */
    equal(first, second) {
        const { name: name1, key: key1 = name1, values: values1 = [], tail: tail1 = [], retry: retry1 = false, } = first;
        const { name: name2, key: key2 = name2, values: values2 = [], tail: tail2 = [], retry: retry2 = false, } = second;
        return (name1 === name2
            && key1 === key2
            && retry1 === retry2
            && arraysAreEqual(values1, values2)
            && arraysAreEqual(tail1, tail2));
    },
};
//# sourceMappingURL=option-input.js.map